import { ReactNode } from 'react'

import { InfoSetDirection } from './infoSetDirection'

export interface InfoSetProps {
  children?: ReactNode
  legend?: ReactNode
  direction?: InfoSetDirection
}
